export const M_Modal_OptionsDefaults = {
	accent: "primary",
	replaceCurrent: false,
	namespace: null,
	lifespan: Infinity,
	props: null,

	onClosed: () => null,
};
